import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

const STATUS = ['new','in_progress','converted','closed'];

export default function AdminEnquiries() {
  const [enqs, setEnqs] = useState([]);
  const [err, setErr] = useState('');

  const load = async () => {
    try { const { data } = await api.get('/admin/enquiries'); setEnqs(data.enquiries||[]); }
    catch (e) { setErr(apiError(e)); }
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (e_, status) => { await api.put(`/employee/enquiries/${e_.id}`, { status }); await load(); };

  return (
    <div data-testid="admin-enquiries">
      <h2 className="mb-3">All enquiries</h2>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="ap-card p-0 overflow-auto">
        <table className="ap-table">
          <thead><tr><th>ID</th><th>Business</th><th>Customer</th><th>Message</th><th>Source</th><th>Status</th><th>Assigned to</th></tr></thead>
          <tbody>
            {enqs.map(e => (
              <tr key={e.id} data-testid={`enq-row-${e.id}`}>
                <td>{e.id}</td>
                <td>{e.business_name}</td>
                <td>
                  <div className="fw-semibold">{e.customer_name}</div>
                  <div className="small text-muted-2">{e.customer_email || e.customer_phone}</div>
                </td>
                <td style={{maxWidth:280}}>{e.message}</td>
                <td>{e.source}</td>
                <td>
                  <select className="form-select form-select-sm" value={e.status} onChange={ev=>setStatus(e, ev.target.value)} data-testid={`enq-status-${e.id}`}>
                    {STATUS.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </td>
                <td>{e.assigned_to_name || '—'}</td>
              </tr>
            ))}
            {enqs.length === 0 && <tr><td colSpan="7" className="text-center py-4 text-muted-2">No enquiries.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
